import React, { useState } from "react";
import { Box, Collapse } from "@mui/material";
import { dt } from "../../../../shared/themes/redesignTokens";

interface SidebarMachineManufacturerProps {
  manufacturerName: string;
  machineCount: number;
  defaultExpanded?: boolean;
  children: React.ReactNode;
}

const SidebarMachineManufacturer: React.FC<SidebarMachineManufacturerProps> = ({
  manufacturerName,
  machineCount,
  defaultExpanded = true,
  children,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Box>
      {/* Manufacturer header row — subtle sub-group */}
      <Box
        onClick={() => setExpanded((prev) => !prev)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
          padding: "10px 8px",
          cursor: "pointer",
          transition: "background-color 0.15s ease",
          borderRadius: "4px",
          "&:hover": { backgroundColor: "#F7F5F0" /* spec: input-bg hover */ },
        }}
      >
        {/* Manufacturer name */}
        <Box
          sx={{
            fontFamily: dt.font,
            fontSize: "11px",
            fontWeight: 500,
            color: "#8C9099", /* spec: text-muted for sub-group */
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            flex: 1,
            minWidth: 0,
          }}
        >
          {manufacturerName}
        </Box>

        {/* Machine count */}
        <Box
          sx={{
            fontFamily: dt.fontMono,
            fontSize: "9px",
            color: "#8C9099", /* spec: text-muted */
            flexShrink: 0,
            whiteSpace: "nowrap",
          }}
        >
          {machineCount}
        </Box>
      </Box>

      {/* Children (machine leaf rows) */}
      <Collapse in={expanded}>
        {children}
      </Collapse>
    </Box>
  );
};

export default SidebarMachineManufacturer;
